import React, {Component} from 'react';
import PropTypes from 'prop-types';
import QuantitySelector from '@homeaway/react-quantity';
import {RadioButton, RadioGroup} from '@homeaway/react-form-components';
import './GuestFields.less';

/**
 * GuestFields
 */
class GuestFields extends Component {
    static propTypes = {
        /** Number of Adults */
        adultsCount: PropTypes.number,
        /** Label for Adults */
        adultsLabel: PropTypes.string,
        /** Label for Increase Adults quantity selector */
        adultsIncreaseLabel: PropTypes.string,
        /** Label for Decrease Adults quantity selector */
        adultsDecreaseLabel: PropTypes.string,
        /** Max Number of Adults */
        adultsMax: PropTypes.number,
        /** Min Number of Adults */
        adultsMin: PropTypes.number,
        /** Number of Children */
        childrenCount: PropTypes.number,
        /** Label for Children */
        childrenLabel: PropTypes.string,
        /** Label for Increase Children quantity selector */
        childrenIncreaseLabel: PropTypes.string,
        /** Label for Decrease Children quantity selector */
        childrenDecreaseLabel: PropTypes.string,
        /** Max Number of Children */
        childrenMax: PropTypes.number,
        /** Min Number of Children */
        childrenMin: PropTypes.number,
        /** pet Checked false by default */
        petIncluded: PropTypes.bool,
        /** Label for pet Yes */
        petLabel: PropTypes.string,
        /** Label for pet Yes */
        petYesLabel: PropTypes.string,
        /** Label for pet No */
        petNoLabel: PropTypes.string,
        /** Show pet Radio Group false by default */
        showpetOption: PropTypes.bool,
        /** Disable inputs edit, true by default */
        disableInput: PropTypes.bool
    }

    static defaultProps = {
        adultsCount: 0,
        childrenCount: 0,
        petIncluded: false,
        showpetOption: false,
        adultsLabel: 'Adult(s)',
        adultsIncreaseLabel: 'Increase Adults',
        adultsDecreaseLabel: 'Decrease Adults',
        adultsMax: 99,
        adultsMin: 0,
        childrenLabel: 'Children',
        childrenIncreaseLabel: 'Increase Children',
        childrenDecreaseLabel: 'Decrease Children',
        childrenMax: 99,
        childrenMin: 0,
        petLabel: 'Pets',
        petYesLabel: 'Yes',
        petNoLabel: 'No',
        disableInput: true,

        className: '',
        onChange: () => {}
    }

    /* istanbul ignore next */
    constructor(props) {
        super(props);

        this.handleAdultsUpdate = this.handleUpdate.bind(this, 'adultsCount');
        this.handleChildrenUpdate = this.handleUpdate.bind(this, 'childrenCount');
        this.handlePetChange = this.handlePetChange.bind(this);
    }

    handleUpdate(key, count) {
        count = parseInt(count, 10);
        this.props.onChange(key, count);
    }

    handlePetChange(event) {
        this.props.onChange(event.target.name, event.target.value === 'true');
    }

    render() {
        const {
            adultsCount,
            adultsLabel,
            adultsIncreaseLabel,
            adultsDecreaseLabel,
            adultsMax,
            adultsMin,
            childrenCount,
            childrenMax,
            childrenMin,
            childrenLabel,
            childrenIncreaseLabel,
            childrenDecreaseLabel,
            petLabel,
            petIncluded,
            petYesLabel,
            petNoLabel,
            showpetOption
        } = this.props;

        return (
            <div>
                <div className="guest-fields" data-wdio="guest-fields">
                    <div className="form-group guest-fields__form-group guest-fields__form-group--adults">
                        <QuantitySelector
                            increaseLabel={adultsIncreaseLabel}
                            decreaseLabel={adultsDecreaseLabel}
                            id="adult-quantity-selector"
                            data-wdio="guest-fields-adult-quantity-selector"
                            min={adultsMin}
                            max={adultsMax}
                            value={adultsCount}
                            onIncrement={this.handleAdultsUpdate}
                            onDecrement={this.handleAdultsUpdate}
                            label={adultsLabel}
                            disableInput
                        />
                    </div>
                    <div className="form-group guest-fields__form-group guest-fields__form-group--children">
                        <QuantitySelector
                            increaseLabel={childrenIncreaseLabel}
                            decreaseLabel={childrenDecreaseLabel}
                            id="children-quantity-selector"
                            data-wdio="guest-fields-children-quantity-selector"
                            value={childrenCount}
                            min={childrenMin}
                            max={childrenMax}
                            onIncrement={this.handleChildrenUpdate}
                            onDecrement={this.handleChildrenUpdate}
                            label={childrenLabel}
                            disableInput
                        />
                    </div>

                    {showpetOption &&
                        <div className="form-group guest-fields__form-group guest-fields__form-group--pet">
                            <label htmlFor="guest-fields-pet" className="guest-fields__label">{petLabel}</label>
                            <div className="guest-fields__radio-group">
                                <RadioGroup id="guest-fields__radio-group--pet" name="petIncluded" ariaLabel="pet included?" label="pet">
                                    <RadioButton
                                        className="guest-fields__radio-button--no-pet"
                                        id="guest-fields-no-pet"
                                        inline
                                        value={false}
                                        label={petNoLabel}
                                        checked={!petIncluded}
                                        onChange={this.handlePetChange}
                                        data-wdio="guest-fields-no-pet-quantity-selector"
                                    />
                                    <RadioButton
                                        className="guest-fields__radio-button--has-pet"
                                        id="guest-fields-pet"
                                        value
                                        label={petYesLabel}
                                        inline
                                        checked={petIncluded}
                                        onChange={this.handlePetChange}
                                        data-wdio="guest-fields-pet-quantity-selector"
                                    />
                                </RadioGroup>
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default GuestFields;
